export type PopoverContainerPosition = 'Top' | 'Bottom';
export const PopoverContainerPosition = {
  Top: 'Top' as PopoverContainerPosition,
  Bottom: 'Bottom' as PopoverContainerPosition,
};

export type PopoverArrowPosition = 'Left' | 'Center' | 'Right';
export const PopoverArrowPosition = {
  Left: 'Left' as PopoverArrowPosition,
  Center: 'Center' as PopoverArrowPosition,
  Right: 'Right' as PopoverArrowPosition,
};
